import { render, staticRenderFns } from "./SelectionCard.vue?vue&type=template&id=1d6783ae"
import script from "./SelectionCard.vue?vue&type=script&lang=js"
export * from "./SelectionCard.vue?vue&type=script&lang=js"
import style0 from "./SelectionCard.vue?vue&type=style&index=0&id=1d6783ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports